export const PaymentConstants = Object.freeze({
  DONATION_TYPE_ONE_TIME: 'one_time_donation',
  DONATION_TYPE_SUBSCRIPTION: 'subscription',
  DONATION_TYPE_MATCHING_GIFT: 'matching_gift_donation',
  DONATION_TYPE_NO_KPI_MATCHING_GIFT: 'no_kpi_matching_gift_donation',
  DONATION_TYPE_CRISIS_EVENT: 'crisis_event_donation',

  // BUSINESS LOGIC: 'succeeded' and 'premium' are the same, they represent a successful payment.
  // Difference is that premium payments get multiplied (doubled, tripled...) by the company, and we need to know that info.
  DONATION_STATUS_SUCCEEDED: 'succeeded',
  DONATION_STATUS_PREMIUM: 'premium',
  DONATION_STATUS_FAILED: 'failed',

});
export enum DonationType {
  ONE_TIME = 'one_time_donation',
  SUBSCRIPTION = 'subscription',
  MATCHING_GIFT = 'matching_gift_donation',
  NO_KPI_MATCHING_GIFT = 'no_kpi_matching_gift_donation',
  CRISIS_EVENT = 'crisis_event_donation',
}
